export default __webpack_public_path__ + "static/media/left_dedication.851b9110.svg";